var sw = require('./../sw');
var $ = require('./../../sw-jquery/sw-jquery');
var _ = require('underscore');
var ShapewaysView = require('./ShapewaysView');

var SUBMIT_TYPES = {
  AJAX: 'ajax',
  NO_AJAX: 'no-ajax'
};

var ShapewaysFormView = ShapewaysView.extend({

  swAttrs: {
    ROOT: 'data-sw-form',
    submitOn: 'data-sw-form-submit-on',
    submitEvent: 'data-sw-form-submit-event'
  },

  // This is auto added but was put here for clarity
  swSelectors: {
    ROOT: '[data-sw-form]' 
  },

  SUBMIT_TYPES: SUBMIT_TYPES,

  submitType: SUBMIT_TYPES.NO_AJAX,

  events: function() {

    var eventsHash = {};

    eventsHash['change [' + this.swAttrs.submitOn + '=change]'] = 'submitForm';
    eventsHash.submit = 'submitEvent';

    return eventsHash;
  },

  initialize: function initialize() {
    this.submittedData = {};
    this.setSubmitType();
    this.subscribeEvents();
  },

  submitEvent: function (e) {
    var hasEmptyRequiredField = false;

    // Check empty fields
    var $requiredFields = this.$(':required');
    _.each($requiredFields, function(field) {
      if(!field.value) {
        hasEmptyRequiredField = true;
        sw.trigger('empty-field-error', field);
      }
    });

    if(hasEmptyRequiredField) {
      e.preventDefault();
      return;
    }

    if(this.$el.attr(this.swAttrs.ROOT) === SUBMIT_TYPES.AJAX) {
      e.preventDefault();
      this.inlineSubmit({});
    }
  },

  subscribeEvents: function() {
    // submit event
    var submitEvent = this.$el.attr(this.swAttrs.submitEvent);
    if (submitEvent) {
      this.listenTo(sw, submitEvent, function() {
        this.submit();
      }, this);
    }
  },

  submit: function() {
    this.$el.trigger('submit');
  },

  serialize: function serialize($form) {
    $form = $form || this.$el;

    var data = $form.serializeArray();
    var values = {};

    _.each(data, function(valuePair) {

      if (valuePair.name.indexOf('[]') > -1) {
        if (!values[valuePair.name]) {
          values[valuePair.name] = [];
        }
        values[valuePair.name].push(valuePair.value);
      } else {
        values[valuePair.name] = valuePair.value;
      }

    });

    return values;
  },

  inlineSubmit: function inlineSubmit(params) {
    var $form = params.$form || this.$el;
    var data = params.data || this.serialize($form);

    this.submittedData = data;

    params = _.extend({
      url: $form.attr('action'),
      data: data,
      type: params.type || 'POST'
    }, params);

    return $.swAjax(params);
  },

  inlinePost: function inlinePost(params) {
    return this.inlineSubmit(_.extend(params, {type: 'POST'}));
  },

  submitForm: function submitForm(e) {
    var $target = $(e.target);
    if (!$target.is('button, input[type=submit]')) {
      this.$el.trigger('submit');
    }
  },

  setSubmitType: function setSubmitType(submitType) {
    submitType = submitType || this.$el.attr(this.swAttrs.ROOT);
    this.submitType = (submitType === SUBMIT_TYPES.AJAX) ? SUBMIT_TYPES.AJAX : SUBMIT_TYPES.NO_AJAX;
  }

});

module.exports = ShapewaysFormView;
